import { StatusIcon, type IconKind } from './StatusIcon';

export interface SubStep {
  id: string;
  label: string;
  status: IconKind;
  current?: boolean;
}

interface Props {
  steps: SubStep[];
}

/**
 * Vertical list of sub-steps under an active phase in the rail. Mirrors the
 * "PHASE 1 PROGRESS" list in the Pull Source Code mockup (Resolve Entities ->
 * Download Package -> Extract Package -> ...).
 */
export function SubStepList({ steps }: Props) {
  return (
    <ul className="sub-step-list">
      {steps.map((step) => (
        <li
          key={step.id}
          className={`sub-step ${step.current ? 'current' : ''} status-${step.status}`}
        >
          <StatusIcon status={step.status} size={14} />
          <span className="sub-step-label">{step.label}</span>
        </li>
      ))}
    </ul>
  );
}
